// Manage cookies
function writeCookieMillis(name, value, millis = 0, onTopDomain = false, shouldEncode) {
    var cookieStr = shouldEncode ?
        encodeURIComponent(name) + '=' + encodeURIComponent(value) :
        name + '=' + value;

    if (typeof document === 'undefined' && typeof global.document === 'undefined') {
        return undefined;
    }

    if (millis !== 0) {
        var now = new Date();
        var then = new Date(now.getTime() + millis);
        var exp = then.toGMTString();
        cookieStr += '; expires=' + exp;
    }

    cookieStr += '; path=/';
    if (onTopDomain) {
        var dom;
        var parts;
        if (isNaN(parseInt(document.domain.replace(/\./g, '')))) {
            parts = document.domain.split('.');
            dom = parts.slice(-2).join('.');
        } else {
            dom = document.domain;
        }

        cookieStr += ';domain=' + dom;
    }

    document.cookie = cookieStr + ';SameSite=Lax';
    return cookieStr;
}

module.exports = {

    KEYS: {
        GPC: 'gpc',
        CCPA_CONSENT_COOKIE: 'ccpaConsentCookie',
        DEVICE_TYPE: 'device_type',
        IS_PREVIEW_ENV_COOKIE: 'preview',
        PREVIEW_COOKIE: 'previewdate',
        SESSIONID: 'JSESSIONID',
        RWD: 'rcps_rwd'
    },

    //temp moved to headerfooter.js remove from headerfooter.js when we are using bTag for analytics
    write: function (name, value, days = 365, top, shouldEncode = true) {
        writeCookieMillis(name, value, days * 86400000, top, shouldEncode);
    },

    delete: function (key, top) {
        writeCookieMillis(key, null, -1, top);
    },

    read: function (key) {
        if (typeof document === 'undefined' && typeof global.document === 'undefined') {
            return null;
        }

        let cookies = ('' + global.document.cookie).split('; ');

        for (let i = 0; i < cookies.length; ++i) {
            let currentCookie = cookies[i].split(/\=(.+)/).filter(Boolean);
            if (currentCookie.length !== 2) {
                /* eslint no-continue: 0 */
                continue;
            }

            const name = global.decodeURIComponent(currentCookie[0]);
            if (key === name) {
                return global.decodeURIComponent(currentCookie[1]);
            }
        }

        return null;
    }
};
